import { render, staticRenderFns } from "./MyActivity.vue?vue&type=template&id=5acd1b54"
import script from "./MyActivity.vue?vue&type=script&lang=js"
export * from "./MyActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports